<ion-item detail="true" lines="none" class="profile-item cursor-ptr" (click)="openPage(menuItem)" mode="md">
  <ion-avatar slot="start">
    <ion-img [src]="menuItem.icon | getImagePipe"></ion-img>
  </ion-avatar>
  <ion-text class="lbl-med-15">{{menuItem.name | getLanguagePipe}}</ion-text>
</ion-item>